import React from "react"

export const getChildrenByType = (children: React.ReactNode, element: unknown) =>
  React.Children.toArray(children).filter(
    (child) => React.isValidElement(child) && child.type === element,
  )
